var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorMsg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 11.1665H5.98818C5.02224 11.1665 4.08236 11.4798 3.3096 12.0594C2.4267 12.7215 1.16675 12.0916 1.16675 10.9879V5.9665C1.16675 4.28635 1.16675 3.44627 1.49373 2.80453C1.78135 2.24005 2.24029 1.7811 2.80478 1.49348C3.44651 1.1665 4.28659 1.1665 5.96674 1.1665H10.3334C11.419 1.1665 11.9618 1.1665 12.4022 1.30535C13.3357 1.59968 14.0669 2.33089 14.3612 3.26439C14.5001 3.70476 14.5001 4.24756 14.5001 5.33317V5.74984M16.2425 17.1514C15.6589 16.5956 14.8839 16.2856 14.078 16.2856H10.2001C9.07997 16.2856 8.51992 16.2856 8.0921 16.0676C7.71577 15.8758 7.40981 15.5699 7.21807 15.1935C7.00008 14.7657 7.00008 14.2057 7.00008 13.0856V11.0332C7.00008 9.91307 7.00008 9.35301 7.21807 8.92519C7.40981 8.54887 7.71577 8.2429 8.0921 8.05116C8.51992 7.83317 9.07997 7.83317 10.2001 7.83317H14.6334C15.7535 7.83317 16.3136 7.83317 16.7414 8.05116C17.1177 8.2429 17.4237 8.54887 17.6154 8.92519C17.8334 9.35301 17.8334 9.91306 17.8334 11.0332V16.4695C17.8334 17.2973 16.842 17.7223 16.2425 17.1514Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMsg);
export default __webpack_public_path__ + "static/media/error-msg.6aeacaadd55989817f948fdfe8cf37b1.svg";
export { ForwardRef as ReactComponent };